module.exports = "images/ico-facebook.svg";